import { AlertIcon } from "@icons";
import { ReactNode } from "react";

interface Alert {
    title: string;
    content: ReactNode;
}

interface AlertsProps {
    alerts?: Alert[];
}

const Alerts = ({ alerts }: AlertsProps) => {
    if (!alerts || alerts.length === 0) {
        return null;
    }

    return (
        <div id="alerts-box" className="bg-[#FFF1F1] border border-[#FFDFDF] rounded-xl p-4 flex flex-col gap-2 w-full">
            {/* Header */}
            <div className="flex flex-col gap-1">
                <div className="flex gap-2 items-center">
                    <AlertIcon className="h-5 w-5 text-red-700" />
                    <h2 className="font-medium text-base leading-6 text-red-700 tracking-[0.16px]">
                        Alerts Center
                    </h2>
                </div>
                <p className="text-sm leading-5 text-neutral-800 tracking-[0.14px]">
                    Please resolve these issues to avoid interruptions to your account.
                </p>
            </div>

            {/* Alert Items */}
            <div className="flex flex-col gap-0">
                {alerts.map((alert, index) => (
                    <div key={index} className="flex flex-col">
                        <div className="flex gap-2 items-center">
                            <div className="border border-neutral-800 rounded-full w-5 h-5 flex items-center justify-center flex-shrink-0">
                                <span className="font-medium text-[10px] leading-3 text-neutral-800 tracking-[0.1px]">
                                    {index + 1}
                                </span>
                            </div>
                            <h3 className="font-normal text-base leading-6 text-neutral-950 tracking-[0.16px]">
                                {alert.title}
                            </h3>
                        </div>
                        <div className="pl-8">
                            <p className="text-sm leading-5 text-neutral-800 tracking-[0.14px]">
                                {alert.content}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Alerts;
